//import $ from "jquery";
import debug from "bows";


const modalBtn = document.querySelectorAll("[data-modal]");
const body = document.querySelector("body");
const top = document.getElementById("top");
const modalOverlay = document.getElementById('modal-overlay');

let focusable = top.querySelectorAll(
	"a,button,input,select,iframe,video,audio, textarea"
);

let current_modal = "";
let video_content = document.getElementById('video-modal__content');
const log = debug("modal");


export function esc() {
	document.addEventListener("keydown", function (evt) {
		evt = evt || window.event;
		var isEscape = false;
		if ("key" in evt) {
			isEscape = evt.key == "Escape" || evt.key == "Esc";
		} else {
			isEscape = evt.keyCode == 27;
		}

		if (isEscape && body.classList.contains("modal-open")) {
			closeModal();
		}
	});
}

function removeFocus() {
	focusable.forEach(elm => {
		elm.setAttribute("tabindex", "-1");
	});
}

function enableFocus() {
	focusable.forEach(elm => {
		elm.removeAttribute("tabindex");
	});
}

export function closeModal() {
	const return_focus = document.querySelector(".return_focus");

	current_modal.classList.remove("modal--show");
	setTimeout(() => {
		current_modal.setAttribute("aria-hidden", true);
		body.classList.remove("modal-open");
	}, 250);

	enableFocus();
	return_focus.focus();
	return_focus.classList.remove("return_focus");

	if (current_modal.getAttribute('id') === "video-modal") {
		video_content.innerHTML = "";
	}
}

function doModal(cm, which) {
	body.classList.add("modal-open");
	cm.setAttribute("aria-hidden", false);
	cm.setAttribute("tabindex", "-1");
	setTimeout(() => {
		cm.classList.add("modal--show");
	}, 150);

	focusable = top.querySelectorAll(
		"a,button,input,select,iframe,video,audio, textarea"
	);
	removeFocus();
	if (which !== 'main-search') {
		cm.focus();
	} else {
		let focusInput = cm.querySelector('input[type="text"]');
		setTimeout(() => {
			focusInput.focus();
		}, 250);
	}
}

export function showModal() {
	const which = this.getAttribute("data-modal");
	current_modal = document.getElementById(which);
	log(which);
	this.classList.add("return_focus");
	doModal(current_modal, which);
}


export function init() {
	log(`modal init`);
	if (modalBtn) {
		const modal_close = document.querySelectorAll(".modal__close");

		modal_close.forEach(btn => {
			btn.addEventListener("click", closeModal);
		});

		esc();

		modalBtn.forEach(btn => {
			btn.addEventListener("click", showModal);
		});
	}


	if (modalOverlay) {
		modalOverlay.addEventListener("click", closeModal);
	}
}

export default {
	init: init,
	showModal: showModal,
	closeModal: closeModal
};
